import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
// import { RequestAddBankDto, RequestBankGetHistoryDto, RequestEditBankDto, ResponseBankAccountGetHistoryDto, ResponseGetBankMultipleDto } from "../../../../shared/nestjs/gd-only/dto/multibank.dto";
import { MultiBankApi } from "../../../../shared/nestjs/gd-only/services/multibank.api";
import { NestResponsesProvider } from "../../../../shared/nestjs/nest-responses";
import { NestApiProvider } from "../../../../shared/nestjs/nest-api";
import { CourseSf6Api } from "../../../../shared/nestjs/gd-integrated/services/course.api";
import { ResponseAddDto, ResponseSaveDto, ResponseDeleteDto } from "../../../../shared/nestjs/gd-integrated/dto/course.dto";
import { PersonalNestApi } from "../../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../../providers/global-service/global-service";

@Injectable()
export class ProfileCourseBloc {

  subscriptions: Array<Subscription> = [];

  constructor(
    public multiBankApi: MultiBankApi,
    public nestResponse: NestResponsesProvider,
    public nestApiProvider: NestApiProvider,
    public courseSf6Api: CourseSf6Api,
    public personalApi: PersonalNestApi,    
    public globalService: GlobalServiceProvider,    
  ) { 
  }

  listing(payload): Observable<any> {
		return this.courseSf6Api.listing(
			payload.empId
		);
	}

	add(data): Observable<ResponseAddDto> {
		return this.courseSf6Api.add(data);
	}

	save(data): Observable<ResponseSaveDto> {
		return this.courseSf6Api.save(data);
	}

	delete(data): Observable<ResponseDeleteDto> {
		return this.courseSf6Api.delete(data);
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('BLOC | getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          console.log('BLOC | resultData', resultData)
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  city(payload): Promise<any> {
    console.log('BLOC | CITY DATA', payload)
    return new Promise((resolve, reject) => {
      this.courseSf6Api.city(payload.search, payload.limit, payload.skip).subscribe(
        async (result) => {
          console.log('BLOC | city', result)
          resolve(result);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  // city(): Observable<any> {
  //   console.log('BLOC | City')
  //   return this.courseSf6Api.city();
	// }
  // editBankRequest(payload: RequestEditBankDto): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.subscriptions.push(
  //       this.multiBankApi.editBankRequest(payload)
  //         .subscribe((result) => {
  //           resolve(result);
  //         }, error => {
  //           reject(error);
  //         })
  //     )
  //   })
  // }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }
}


// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-course/profile-course.bloc.ts